import React from "react";
import { useNavigate } from "react-router-dom";
import TripCard, { ACTIVE_STATUSES } from "./TripCard";

const FINAL = ["completed", "cancelled"];

export function splitTrips(trips) {
  const now = Date.now();
  const upcoming = [], past = [];
  for (const t of trips) {
    const ts = Date.parse(t.pickup_datetime || "") || 0;
    const isActive = ACTIVE_STATUSES.includes(t.status);
    const isFuture = ts >= now - 6 * 3600 * 1000; // 6h grace so a running trip stays "upcoming"
    if (!FINAL.includes(t.status) && (isFuture || isActive)) upcoming.push(t);
    else past.push(t);
  }
  upcoming.sort((a, b) => Date.parse(a.pickup_datetime) - Date.parse(b.pickup_datetime));
  past.sort((a, b) => Date.parse(b.pickup_datetime) - Date.parse(a.pickup_datetime));
  return { upcoming, past };
}

export default function MyTrips({ trips, busy, onChanged }) {
  const nav = useNavigate();
  if (busy) return <div className="text-[#A1A1AA]" data-testid="trips-loading">Loading your trips…</div>;

  if (trips.length === 0) {
    return (
      <div className="border border-white/10 p-12 text-center bg-[#0A0A0A]" data-testid="trips-empty">
        <div className="font-serif text-2xl text-[#F5F2EB] mb-3">No trips yet.</div>
        <p className="text-[#A1A1AA] mb-6 text-sm">Book your first ride to get started.</p>
        <button data-testid="empty-book-cta" className="btn-gold" onClick={() => nav("/book")}>Book a ride</button>
      </div>
    );
  }

  const { upcoming, past } = splitTrips(trips);
  return (
    <div className="space-y-12" data-testid="my-trips">
      <section data-testid="upcoming-trips">
        <div className="flex items-baseline justify-between mb-4">
          <h2 className="font-serif text-2xl md:text-3xl">Upcoming</h2>
          <span className="overline" data-testid="upcoming-count">{upcoming.length} {upcoming.length === 1 ? "trip" : "trips"}</span>
        </div>
        {upcoming.length === 0 ? (
          <div className="border border-dashed border-white/10 p-8 text-center text-sm text-[#A1A1AA]" data-testid="upcoming-empty">
            Nothing on the calendar.{" "}
            <button data-testid="upcoming-book-cta" className="text-[#D4AF37] underline-offset-4 hover:underline" onClick={() => nav("/book")}>Book a ride →</button>
          </div>
        ) : (
          <div className="space-y-4">{upcoming.map(t => <TripCard key={t.booking_id} t={t} onChanged={onChanged}/>)}</div>
        )}
      </section>

      <section data-testid="past-trips">
        <div className="flex items-baseline justify-between mb-4">
          <h2 className="font-serif text-2xl md:text-3xl">Past</h2>
          <span className="overline" data-testid="past-count">{past.length} {past.length === 1 ? "trip" : "trips"}</span>
        </div>
        {past.length === 0 ? (
          <div className="border border-dashed border-white/10 p-8 text-center text-sm text-[#A1A1AA]" data-testid="past-empty">No past trips yet.</div>
        ) : (
          <div className="space-y-4">{past.map(t => <TripCard key={t.booking_id} t={t} onChanged={onChanged}/>)}</div>
        )}
      </section>
    </div>
  );
}
